module.exports = __webpack_public_path__ + "img/negroni.9c754802.jpg";